// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5790":"69be244c","7856":"ce88f3d3"}[chunkId] + ".chunk.css";
};